import { withCombinedStreet } from 'platform/shared/health-apps';
import PropTypes from 'prop-types';
import React from 'react';

const getAddressLines = address => {
  const { streetCombined, city, state, postalCode, country } =
    withCombinedStreet(address, { newLine: true });
  const locality = [[city, state].filter(Boolean).join(', '), postalCode]
    .filter(Boolean)
    .join(' ');
  return [
    ...streetCombined.split('\n'),
    locality,
    country !== 'USA' ? country : null,
  ].filter(Boolean);
};

const AddressLines = ({ address }) =>
  getAddressLines(address ?? {}).map((line, index) => (
    <React.Fragment key={index}>
      {index > 0 && <br />}
      {line}
    </React.Fragment>
  ));

AddressLines.propTypes = {
  address: PropTypes.object,
};

export default AddressLines;
